export { DetailCheckout } from './detailCheckout';
